<svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3041_14818)">
<rect x="2.35" y="1.85" width="18.3" height="18.3" rx="2.15" stroke="currentColor" stroke-width="1.7"/>
<rect width="1.5" height="25.3702" rx="0.75" transform="matrix(0.499684 0.866208 -0.72077 0.693174 20.2683 1.5575)" fill="currentColor"/>
<rect width="1.5" height="25.3706" rx="0.75" transform="matrix(0.499729 -0.866182 0.720729 0.693217 1.98248 2.85614)" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_3041_14818">
<rect width="22" height="22" fill="white" transform="translate(0.5)"/>
</clipPath>
</defs>
</svg>
